import React from 'react';

import Select from 'antd/es/select';

import FormikField, { FormikFieldProps } from '@common/react/components/Forms/FormikField/FormikField';

export interface FormikFieldSelectProps<T extends PropertyKey> extends FormikFieldProps {
	options: Record<T, string>;
	className?: string;
	placeholder?: string;
}

export const SelectForEnum: <T extends PropertyKey, >(
	props: FormikFieldSelectProps<T>,
) => React.ReactElement<T> = <T extends PropertyKey, >(
	props: FormikFieldSelectProps<T>,
) => {
	const {
		options,
		placeholder = '',
		className = '',
		...rest
	} = props;

	const items = Object.keys(options);

	return (<FormikField
		render={({ field, form }) => (
			<Select
				{...field}
				className={className}
				placeholder={placeholder}
				onChange={(value) => form.setFieldValue(field.name, +value)}
			>
				{items.map((q) => <Select.Option key={+q} value={+q}>{options[+q]}</Select.Option>)}
			</Select>
		)}
		{...rest}
	/>);
};
